import React from 'react'

const index = () => {
  return (
    <div>
      <h1>Page not Found</h1>
    </div>
  )
}

export default index
